import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  btnRight: {
    "&.MuiButton-root": {
      marginLeft: theme.spacing(2),
    },
  },
  entrepotHead: {
    display: "flex",
    "& svg": {
      marginLeft: "5px",
      opacity: 0,
    },
    "&.admin:hover svg": {
      opacity: 1,
    },
    "&.admin": {
      cursor: "pointer",
      color: `${theme.color.red} !important`,
    },
    "&.admin.actual": {
      color: `${theme.color.green} !important`,
    },
  },
  modal: {
    display: "flex",
    padding: theme.spacing(1),
    alignItems: "center",
    justifyContent: "center",
  },
  noResultPlaceHolder: {
    minHeight: "420px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paperModal: {
    flex: "0 1 500px",
    width: 500,
    maxWidth: "100%",
  },
  fileDownloader: {
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  filename: {
    flex: 1,
  },
  rowStock: {
    display: "flex",
    flex: 1,
  },
  rowStockEntrepot: {
    marginRight: theme.spacing(4),
  },
  select: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
}));
